import React from 'react';
import classNames from 'classnames';
import {Dummy} from '../'
import styles from './style.css';

export default class BA extends Dummy {


    paintCanvas(cvs, disabled, s1 = 0, s2 = 1, s3 = 0) {
        var canvas = document.getElementById(cvs);
        if (canvas.getContext) {
            var ctx = canvas.getContext('2d');

            if (disabled) {
                ctx.strokeStyle = "black";
                ctx.strokeRect(24, 21, 131, 439);
                ctx.fillStyle = "grey";
                ctx.fillRect(24, 21, 131, 439);
            }
            else {
                ctx.strokeStyle = "black";
                ctx.strokeRect(24, 21, 131, 439);
                ctx.fillStyle = "white";
                ctx.fillRect(24, 21, 131, 439);
                if (s1 === 1 && s2 === 0 && s3 === 0) {
                    ctx.fillStyle = "blue";
                    ctx.fillRect(24, 124, 131, 356);
                }
                else if (s1 === 0 && s2 === 1 && s3 === 0) {
                    ctx.fillStyle = "blue";
                    ctx.fillRect(24, 102, 131, 358);
                }
                else if (s1 === 0 && s2 === 0 && s3 === 1) {
                    ctx.fillStyle = "blue";
                    ctx.fillRect(24, 66, 131, 394);

                }
                else if (s1 === 0 && s2 === 0 && s3 === 0) {
                    ctx.fillStyle = "white";
                    ctx.fillRect(24, 21, 131, 439);

                }
            }

            ctx.beginPath();
            ctx.moveTo(41, 31);
            ctx.lineTo(41, 12);
            ctx.stroke();
            ctx.beginPath();
            ctx.arc(31, 12, 10, Math.PI * 1, Math.PI * 0, false);
            ctx.stroke();
            ctx.beginPath();
            ctx.moveTo(21, 12);
            ctx.lineTo(21, 60);
            ctx.stroke();
            ctx.beginPath();
            ctx.arc(11, 60, 10, Math.PI * 1, Math.PI * 0, true);
            ctx.stroke();
            ctx.beginPath();
            ctx.moveTo(1, 60);
            ctx.lineTo(1, 46);
            ctx.stroke();
            ctx.closePath();

            ctx.fillStyle = "black";
            ctx.font = "12px Open Sans";
            ctx.fillText("БА", 75, 14);
        }
    };


    render() {
        let tankClass = {};
        let s1 = this.props.ps[0];
        let s2 = this.props.ps[1];
        let s3 = this.props.ps[2];

        tankClass[styles.low] = !s1.cleaned && !s2.cleaned && s3.cleaned;
        tankClass[styles.high] = s1.cleaned && !s2.cleaned && !s3.cleaned;

        return (
            <div id={this.props.div_id} className={classNames(this.props.className, styles.wrap)}>
                <canvas className='cvs' id={this.props.canvas_id} width="157" height="461"/>
                <div className={classNames(styles.default, tankClass)}/>
            </div>
        );
    }
}

BA.propTypes = {
    canvas_id: React.PropTypes.string,
    div_id: React.PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/components/entries/BA/index.jsx